import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiUrl from '../../Apiurl';
import RicercaAvanzataOrdiniPOP from '../AreaOrdiniComponenti/DBperAreaOrdiniComponenti/RicercaAvanzataOrdiniPOP';
import { PieChart } from "@mui/x-charts/PieChart";
import { formatDashboardOrdiniFilters } from "./dashboardOrdiniMeta";

function StatDatiConfronta({
    mobile,
    token,
    campiRicerca
}) {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState(null); // {}
    const [showModal, setShowModal] = useState(false);

    // Initial load: maybe empty? Or default?
    // User probably wants to set filters first.
    
    useEffect(() => {
        const load = async () => {
             if (!token || !filters) return;
             setLoading(true);
             try {
                 const params = new URLSearchParams({
                     filters: JSON.stringify(filters)
                 });
                 const res = await axios.get(`${apiUrl}/contab/charts/statisticheCustom?${params.toString()}`, {
                     headers: { Authorization: `Bearer ${token}` }
                 });
                 setStats(res.data);
             } catch (err) {
                 console.error(err);
             } finally {
                 setLoading(false);
             }
        };
        load();
    }, [filters, token]);


    const renderPie = (title, dataArr) => {
        const cheerfulFiestaPalette = [
            "#ff9800", "#009688", "#1565c0", "#9c27b0", "#b71c1c",
            "#e91e63", "#8bc34a", "#00bcd4", "#795548", "#607d8b"
        ];
        
        const data = Array.isArray(dataArr) ? dataArr.map(d => ({
            label: d.label,
            value: Number(d.value)
        })) : [];
        
        if (data.length === 0) return null;

        return (
            <div className="pa2 w-100 w-50-m w-20-l flex flex-column items-center">
                <div className="tc b ttu">{title}</div>
                <PieChart
                    series={[{
                        data: data,
                        innerRadius: 40,
                        outerRadius: 100,
                        arcLabel: (item) => item.value > 0 ? String(item.value) : ''
                    }]}
                    width={300}
                    height={250}
                    colors={cheerfulFiestaPalette}
                    legend={{ hidden: true }}
                />
                 {/* Simple Legend */}
                 <div className="f7 mt2">
                     {data.slice(0,5).map((d, i) => (
                         <div key={i} className="flex justify-between w-100">
                             <span className="b mr2">{d.label}:</span>
                             <span>{d.value}</span>
                         </div>
                     ))}
                 </div>
            </div>
        );
    };

    const renderList = (title, items, isImporto) => {
        if (!items || items.length === 0) return null;
        return (
            <div className="w-100 w-50-ns pa2">
                 <div className="b tc mt3 mb3 ttu f4">{title}</div>
                 <div className="flex flex-wrap">
                      {items.map((item, i) => (
                          <div key={i} className="ba b--black-10 br3 pa2 ma1 w-100 flex items-center">
                              <div className="w-10 b f3 gray mr2">#{i+1}</div>
                              <div className="w-90">
                                  <div className="b">{item.nomeArticolo}</div>
                                  <div className="f7 gray">Prod: {item.brand} | Cod: {item.label}</div>
                                  <div className="mt1">
                                      <span className="b">{isImporto ? 'Valore' : 'Quantità'}: </span>
                                      {isImporto 
                                        ? Number(item.value).toLocaleString('it-IT', {style:'currency', currency:'EUR'}) 
                                        : item.value}
                                  </div>
                              </div>
                          </div>
                      ))}
                 </div>
            </div>
        )
    }

    return (
        <div className="sfondoBiancoTema pa3 mb3">
             <div className="tc b mb2 f4">Dati Confronto Personalizzato</div>
             <div className="tc mb3">
                 <button className="dim tastoInputOrizzontale br2 pa2" onClick={() => setShowModal(true)}>
                     {filters ? "Modifica Filtri" : "Imposta Filtri"}
                 </button>
             </div>
             
             {filters && (
                 <div className="tc gray f7 mb3">
                     Filtri attivi: {formatDashboardOrdiniFilters(filters, campiRicerca)}
                 </div>
             )}

             {loading && <div className="tc pa3">Caricamento statistiche...</div>}
             
             {stats && !loading && (
                 <div className="flex flex-wrap justify-around">
                     {renderPie("Stato Ordine", stats.stati)}
                     {renderPie("Reparti", stats.reparti)}
                     {renderPie("Categorie", stats.categorie)}
                     {renderPie("Brand", stats.brand)}
                     
                     <div className="w-100 flex flex-wrap mt4">
                         {renderList("Top 10 Quantità", stats.topQty, false)}
                         {renderList("Top 10 Importo", stats.topImporto, true)}
                     </div>
                 </div>
             )}
             
             {showModal && (
                 <div className="fixed top-0 left-0 w-100 h-100 flex items-center justify-center bg-black-60 z-max" onClick={() => setShowModal(false)} style={{zIndex: 9999}}>
                     <div className="bg-white pa3 br3 overflow-y-auto" style={{ maxHeight: '90vh', width: '90%' }} onClick={e => e.stopPropagation()}>
                         <RicercaAvanzataOrdiniPOP
                            setPopUpWindow={setShowModal}
                            campiRicerca={campiRicerca}
                            setRicerca={(inp) => {
                                setFilters(inp);
                                setShowModal(false);
                            }}
                            soloFiltri={true}
                         />
                     </div>
                 </div>
             )}
        </div>
    );
}

export default StatDatiConfronta;
